import React from "react"

import AddCircleIcon from "@mui/icons-material/AddCircle"
import RemoveCircleIcon from "@mui/icons-material/RemoveCircle"
import DragIndicatorIcon from "@mui/icons-material/DragIndicator"

import {useStateProviderValue} from "../context/StateProvider"

import {UPDATE_RIGHT_SIDE_DATA} from "../types"

const RightSide = () => {
	const {state, dispatch} = useStateProviderValue()

	const [rightSideData, setRightSideData] = React.useState(state.rightSide)

	React.useEffect(() => {
		setRightSideData(state.rightSide)
	}, [state])

	//update rightSide data state
	const updateRightSideState = (data: typeof state.rightSide) => {
		dispatch({
			type: UPDATE_RIGHT_SIDE_DATA,
			rightSide: data,
		})
	}

	//Add or remove dynamic rows, sections for rightSide

	//add new section
	const addNewSection = () => {
		//sort the website array by order
		const _sections = rightSideData.sections.sort((a, b) =>
			a.id > b.id ? 1 : -1,
		)

		//get new id by incrementing last website's id by 1
		const newId = _sections[_sections.length - 1].id + 1

		//get new order by incrementing current order
		const newOrder =
			_sections.sort((a, b) => (a.order > b.order ? 1 : -1))[
				_sections.length - 1
			].order + 1

		//push new object to section array
		_sections.push({
			id: newId,
			order: newOrder,
			title: "",
			rows: [
				{
					order: 1,
					id: 1,
					title: "",
					subTitle: "",
					details: [
						{
							order: 1,
							id: 1,
							detail: "",
						},
					],
				},
			],
		})

		let _rightSideData = {...rightSideData} as any
		_rightSideData.sections = _sections
		updateRightSideState(_rightSideData)
	}

	//remove section
	const removeSection = (id: number) => {
		let _sections = rightSideData.sections
		let _rightSideData = {...rightSideData} as any

		//remove current site with id from the website array
		_sections = _sections.filter((s) => s.id !== id)
		_rightSideData.sections = _sections
		updateRightSideState(_rightSideData)
	}

	//Add  row inside section
	const addRowsForSection = (sectionId: number) => {
		let _sections = rightSideData.sections
		let _rightSideData = {...rightSideData} as any

		//find current section index
		let index = _sections.findIndex((s) => s.id === sectionId)

		//get sorted rows
		let _rows = _sections[index].rows.sort((a, b) => (a.id > b.id ? 1 : -1))

		//new id for row
		const newId = _rows[_rows.length - 1].id + 1

		//new orderId for row
		const newOrderId =
			_rows.sort((a, b) => (a.order > b.order ? 1 : -1))[_rows.length - 1]
				.order + 1

		//push new empty row for rows
		_sections[index].rows.push({
			order: newOrderId,
			id: newId,
			title: "",
			subTitle: "",
			details: [
				{
					order: 1,
					id: 1,
					detail: "",
				},
			],
		})
		_rightSideData.sections = _sections
		updateRightSideState(_rightSideData)
	}

	//remove row inside section
	const removeRowsForSection = (sectionId: number, rowId: number) => {
		let _sections = rightSideData.sections
		let _rightSideData = {...rightSideData} as any

		//find current section index
		let index = _sections.findIndex((s) => s.id === sectionId)

		//filtered rows
		let _rows = _sections[index].rows.filter((row) => row.id !== rowId)

		_sections[index].rows = _rows
		_rightSideData.sections = _sections
		updateRightSideState(_rightSideData)
	}
	//remove detail row
	const removeDetailRow = (
		sectionId: number,
		rowId: number,
		detailId: number,
	) => {
		let _sections = rightSideData.sections
		let _rightSideData = {...rightSideData} as any

		//find current section index
		let sectionIndex = _sections.findIndex((s) => s.id === sectionId)

		//get row index
		let rowIndex = _sections[sectionIndex].rows.findIndex(
			(row) => row.id === rowId,
		)

		//filtered rows
		let _details = _sections[sectionIndex].rows[rowIndex].details.filter(
			(d) => d.id !== detailId,
		)

		_sections[sectionIndex].rows[rowIndex].details = _details
		_rightSideData.sections = _sections
		updateRightSideState(_rightSideData)
	}

	//Add  row inside details
	const addDetailRow = (sectionId: number, rowId: number) => {
		let _sections = rightSideData.sections
		let _rightSideData = {...rightSideData} as any

		//find current section index
		let sectionIndex = _sections.findIndex((s) => s.id === sectionId)

		//get row index
		let rowIndex = _sections[sectionIndex].rows.findIndex(
			(row) => row.id === rowId,
		)

		//get sorted details
		let _details = _sections[sectionIndex].rows[rowIndex].details.sort((a, b) =>
			a.id > b.id ? 1 : -1,
		)

		//new id for row
		const newId = _details[_details.length - 1].id + 1

		//new orderId for row
		const newOrderId =
			_details.sort((a, b) => (a.order > b.order ? 1 : -1))[_details.length - 1]
				.order + 1

		//push new empty row for details
		_sections[sectionIndex].rows[rowIndex].details.push({
			order: newOrderId,
			id: newId,
			detail: "",
		})
		_rightSideData.sections = _sections
		updateRightSideState(_rightSideData)
	}

	//Handle data changes
	//handle object level data change from rightSide object
	const handleRightSideChange = (
		event:
			| React.ChangeEvent<HTMLInputElement>
			| React.ChangeEvent<HTMLTextAreaElement>,
	) => {
		let _rightSideData = {...rightSideData} as any

		if (event.target.name === "order") {
			_rightSideData[event.target.name] = parseInt(event.target.value)
		} else {
			_rightSideData[event.target.name] = event.target.value
		}
		updateRightSideState(_rightSideData)
	}

	//handle section main data change
	const handleSectionMainData = (
		id: number,
		event: React.ChangeEvent<HTMLInputElement>,
	) => {
		let _sections = rightSideData.sections as any
		let _rightSideData = {...rightSideData} as any

		//find current section index
		let index = _sections.findIndex((s: any) => s.id === id)

		if (event.target.name === "order") {
			_sections[index][event.target.name] = parseInt(event.target.value)
		} else {
			_sections[index][event.target.name] = event.target.value
		}

		_rightSideData.sections = _sections
		updateRightSideState(_rightSideData)
	}

	//handle section's inner row data
	const handleSectionRowData = (
		sectionId: number,
		rowId: number,
		event: React.ChangeEvent<HTMLInputElement>,
	) => {
		let _sections = rightSideData.sections as any
		let _rightSideData = {...rightSideData} as any

		//find current section index
		let sectionIndex = _sections.findIndex((s: any) => s.id === sectionId)

		//find row index
		let rowIndex = _sections[sectionIndex].rows.findIndex(
			(r: any) => r.id === rowId,
		)

		if (event.target.name === "order") {
			_sections[sectionIndex].rows[rowIndex][event.target.name] = parseInt(
				event.target.value,
			)
		} else {
			_sections[sectionIndex].rows[rowIndex][event.target.name] =
				event.target.value
		}

		_rightSideData.sections = _sections
		updateRightSideState(_rightSideData)
	}

	//handle detail data
	const handleDetailData = (
		sectionId: number,
		rowId: number,
		detailId: number,
		event: React.ChangeEvent<HTMLInputElement>,
	) => {
		let _sections = rightSideData.sections as any
		let _rightSideData = {...rightSideData} as any

		//find current section index
		let sectionIndex = _sections.findIndex((s: any) => s.id === sectionId)

		//find row index
		let rowIndex = _sections[sectionIndex].rows.findIndex(
			(r: any) => r.id === rowId,
		)

		//find detail index
		let detailIndex = _sections[sectionIndex].rows[rowIndex].details.findIndex(
			(d: any) => d.id === detailId,
		)

		if (event.target.name === "order") {
			_sections[sectionIndex].rows[rowIndex].details[detailIndex][
				event.target.name
			] = parseInt(event.target.value)
		} else {
			_sections[sectionIndex].rows[rowIndex].details[detailIndex][
				event.target.name
			] = event.target.value
		}

		_rightSideData.sections = _sections
		updateRightSideState(_rightSideData)
	}

	return (
		<div className="right-side">
			<div className="input-group">
				<label htmlFor="">Full name</label>
				<input
					type="text"
					name="fullName"
					value={rightSideData.fullName}
					placeholder="John Doe"
					onChange={handleRightSideChange}
				/>
			</div>
			<div className="input-group">
				<label htmlFor="">Job title</label>
				<input
					type="text"
					name="jobTitle"
					value={rightSideData.jobTitle}
					placeholder="Full stack developer"
					onChange={handleRightSideChange}
				/>
			</div>
			<div className="input-group">
				<label htmlFor="">Profile summary</label>

				<textarea
					name="profileSummary"
					value={rightSideData.profileSummary}
					placeholder="Write a short profile description.."
					rows={3}
					cols={40}
					onChange={handleRightSideChange}
				/>
			</div>

			{/** Right side section row dynamic*/}

			<div className="section-left-side">
				<h2 className="section-title">Sections</h2>
				<h3>Add new section to display in the left side sections</h3>

				{/** Dynamic section render for right side */}
				{rightSideData.sections.map((section, index) => (
					<div className="section-wrap" key={section.id}>
						<div className="section-wrap__head-action">
							<div className="input-order">
								<DragIndicatorIcon />
								<input
									type="text"
									name="order"
									value={section.order}
									className="input-order"
									onChange={(event) => handleSectionMainData(section.id, event)}
								/>
							</div>
							{rightSideData.sections.length > 1 && index !== 0 && (
								<span
									className="btn btn__normal"
									onClick={() => removeSection(section.id)}>
									Delete section
								</span>
							)}
						</div>

						<div className="input-group">
							<label htmlFor="">Section title</label>
							<input
								type="text"
								name="title"
								value={section.title}
								placeholder="Experiences"
								onChange={(event) => handleSectionMainData(section.id, event)}
							/>
						</div>
						{/** Section's inner dynamic row group */}
						{section.rows.map((row, index) => (
							<div className="section-row" key={row.id}>
								<div className="section-wrap__head-action">
									<div className="input-order">
										<DragIndicatorIcon />
										<input
											type="text"
											name="order"
											value={row.order}
											className="input-order"
											onChange={(event) =>
												handleSectionRowData(section.id, row.id, event)
											}
										/>
									</div>
									{section.rows.length > 1 && index !== 0 && (
										<span
											className="btn btn__normal"
											onClick={() => removeRowsForSection(section.id, row.id)}>
											Delete
										</span>
									)}
								</div>

								<div className="input-group">
									<label htmlFor="">Title</label>
									<input
										type="text"
										name="title"
										value={row.title}
										placeholder="Web developer"
										onChange={(event) =>
											handleSectionRowData(section.id, row.id, event)
										}
									/>
								</div>

								<div className="input-group">
									<label htmlFor="">Sub label</label>
									<input
										type="text"
										name="subTitle"
										value={row.subTitle}
										placeholder="Company Name | StockHolm | June 2020- present"
										onChange={(event) =>
											handleSectionRowData(section.id, row.id, event)
										}
									/>
								</div>

								{/** Row's inner detail row */}
								<div className="details">
									{row.details.map((detail, index) => (
										<div className="details__list" key={detail.id}>
											<div className="input-order">
												<DragIndicatorIcon />
												<input
													type="text"
													name="order"
													value={detail.order}
													onChange={(event) =>
														handleDetailData(
															section.id,
															row.id,
															detail.id,
															event,
														)
													}
												/>
											</div>
											<div className="input-group">
												<label htmlFor="">
													{row.title ? `${row.title} detail` : "Detail"}
												</label>
												<input
													type="text"
													name="detail"
													placeholder={row.title ? `${row.title}` : "Detail"}
													value={detail.detail}
													onChange={(event) =>
														handleDetailData(
															section.id,
															row.id,
															detail.id,
															event,
														)
													}
												/>
											</div>
											<div className="input-action">
												{row.details.length - 1 === index ? (
													<>
														<RemoveCircleIcon
															onClick={() =>
																removeDetailRow(section.id, row.id, detail.id)
															}
														/>
														<AddCircleIcon
															onClick={() => addDetailRow(section.id, row.id)}
														/>
													</>
												) : (
													<RemoveCircleIcon
														onClick={() =>
															removeDetailRow(section.id, row.id, detail.id)
														}
													/>
												)}
											</div>
										</div>
									))}
								</div>
							</div>
						))}
						<button
							className="btn btn__dark-outline mt-4 mb-2"
							onClick={() => addRowsForSection(section.id)}>
							{section.title
								? `Add new ${section.title.toLowerCase()}`
								: "Add new row"}
						</button>
					</div>
				))}

				<button className="btn btn__dark-outline mt-4" onClick={addNewSection}>
					Add new section
				</button>
			</div>
		</div>
	)
}

export default RightSide
